export class Email {
  value: string = "2";

  static build(email: string = ""): Email {
    const entity = new Email();
    entity.value = email;
    return entity;
  }

  validate() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.value);
  }

  toString() {
    return this.value ?? "nulo";
  }
}
